// extracted by mini-css-extract-plugin
export var labelWrapper = "_dx-0";